import React from "react";
import Logo from "../assets/codeigniter-logo.svg"

const Header = () => {
    return (
       <div className="flex justify-center items-center gap-8 pt-8">
         <img src={Logo} alt="My logo" className="h-10 w-10"/>
         <h2 className="text-2xl font-bold">Coding Conf</h2>
       </div>
    )
}

export default Header